import React, { FC } from 'react';
import { Box, TextField } from '@mui/material';
import { ADDITIONAL_FIELDS_META } from '../../model';
import { AdditionalFieldsSectionProps } from '../../types/additionalFieldsForm';
import { useAdditionalFieldsHandlers } from '../../hooks/useAdditionalFieldsHandlers';
import { AdditionalSelectField } from '../AdditionalSelectField';

type CampaignMetaSectionProps = AdditionalFieldsSectionProps &
  Pick<
    ReturnType<typeof useAdditionalFieldsHandlers>,
    | 'handleTextChange'
    | 'handleBlur'
    | 'handleTextKeyDown'
    | 'handleSelectChange'
    | 'handleSelectClear'
  >;

export const CampaignMetaSection: FC<CampaignMetaSectionProps> = ({
  values,
  isFieldsDisabled,
  handleTextChange,
  handleBlur,
  handleTextKeyDown,
  handleSelectChange,
  handleSelectClear,
}) => (
  <>
    <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
      <TextField
        label={ADDITIONAL_FIELDS_META.verifiers.label}
        variant="standard"
        value={values.verifiers ?? ''}
        disabled={isFieldsDisabled}
        onChange={handleTextChange('verifiers')}
        onBlur={handleBlur('verifiers')}
        onKeyDown={handleTextKeyDown('verifiers')}
        sx={{ flex: 1, minWidth: 200 }}
      />
    </Box>

    <Box display="flex" gap={2} flexWrap="wrap">
      <AdditionalSelectField
        label={ADDITIONAL_FIELDS_META.ord.label}
        value={values.ord}
        options={ADDITIONAL_FIELDS_META.ord.enumValues ?? []}
        disabled={isFieldsDisabled}
        onChange={handleSelectChange('ord')}
        onClear={handleSelectClear('ord')}
      />
      <AdditionalSelectField
        label={ADDITIONAL_FIELDS_META.materialType.label}
        value={values.materialType}
        options={ADDITIONAL_FIELDS_META.materialType.enumValues ?? []}
        disabled={isFieldsDisabled}
        minWidth={300}
        onChange={handleSelectChange('materialType')}
        onClear={handleSelectClear('materialType')}
      />
    </Box>
  </>
);
